var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-footer w" },
    [
      _c("div", { staticClass: "links" }, [
        _c("div", { staticClass: "col robot" }, [
          _c("h3", [_vm._v("产品信息")]),
          _c(
            "a",
            {
              on: {
                click: function($event) {
                  _vm.routeGo("/robot3s/info")
                }
              }
            },
            [_vm._v("维拉3S")]
          ),
          _c(
            "a",
            {
              on: {
                click: function($event) {
                  _vm.routeGo("/robot3/info")
                }
              }
            },
            [_vm._v("维拉3")]
          ),
          _c(
            "a",
            {
              on: {
                click: function($event) {
                  _vm.routeGo("/robot2s/info")
                }
              }
            },
            [_vm._v("维拉2S")]
          )
        ]),
        _c("div", { staticClass: "col service" }, [
          _c("h3", [_vm._v("售后服务")]),
          _c(
            "a",
            {
              on: {
                click: function($event) {
                  _vm.routeGo("/service#maintenance")
                }
              }
            },
            [_vm._v("售后电话")]
          ),
          _c(
            "a",
            {
              on: {
                click: function($event) {
                  _vm.routeGo("/service#maintenance")
                }
              }
            },
            [_vm._v("报修方式")]
          )
        ]),
        _c("div", { staticClass: "col about" }, [
          _c("h3", [_vm._v("关于我们")]),
          _c(
            "a",
            {
              on: {
                click: function($event) {
                  _vm.routeGo("/about#company-profile")
                }
              }
            },
            [_vm._v("公司简介")]
          ),
          _c(
            "a",
            {
              on: {
                click: function($event) {
                  _vm.routeGo("/about#contact-us")
                }
              }
            },
            [_vm._v("联系我们")]
          ),
          _c(
            "a",
            {
              on: {
                click: function($event) {
                  _vm.routeGo("/news")
                }
              }
            },
            [_vm._v("新闻动态")]
          )
        ]),
        _c(
          "div",
          { staticClass: "col cocern" },
          [
            _c("h3", [_vm._v("关注我们")]),
            _c(
              "a",
              { staticClass: "weixin", on: { click: _vm.showWeixinPop } },
              [
                _c("span", [_vm._v("官方微信")]),
                !_vm.isMobile
                  ? _c("img", {
                      staticClass: "qr-img",
                      attrs: { src: require("../assets/web/qr-weixin.png") }
                    })
                  : _vm._e()
              ]
            ),
            _vm.isMobile
              ? _c(
                  "a",
                  {
                    staticClass: "weibo",
                    attrs: { href: "//weibo.com/u/3772228124" }
                  },
                  [_vm._v("新浪微博")]
                )
              : _c(
                  "a",
                  {
                    staticClass: "weibo",
                    attrs: {
                      href: "//weibo.com/u/3772228124",
                      target: "_black"
                    }
                  },
                  [_vm._v("新浪微博")]
                ),
            _vm.isMobile ? [_vm._m(0)] : [_vm._m(1)]
          ],
          2
        ),
        _vm._m(2)
      ]),
      _vm._m(3),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.weixinPopShow
          ? _c(
              "div",
              {
                staticClass: "weixin-pop",
                on: {
                  click: function($event) {
                    _vm.weixinPopShow = 0
                  }
                }
              },
              [
                _c("img", {
                  attrs: { src: require("../assets/web/qr-weixin.png") }
                })
              ]
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "app",
        attrs: {
          href: "http://www.flyingwings.com.cn/download/app/",
          target: "_black"
        }
      },
      [_c("span", [_vm._v("APP下载")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "app" }, [
      _c("span", [_vm._v("APP下载")]),
      _c("img", {
        staticClass: "qr-img",
        attrs: { src: require("../assets/web/qr-app.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col tel" }, [
      _c("h3", [_vm._v("公司总机")]),
      _c("a", { attrs: { href: "tel:193 0215 5869" } }, [
        _vm._v("193 0215 5869")
      ]),
      _c("p", [_vm._v("工作日9:00-18:00")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "copyright" }, [
      _vm._v("Copyright © 2013-2022 Flyingwings Co.,Ltd. "),
      _c(
        "a",
        { attrs: { href: "https://beian.miit.gov.cn/", target: "_blank" } },
        [_vm._v("沪ICP备12048554号")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46c3e992", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46c3e992","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-footer.vue
// module id = 6fJm
// module chunks = 0